import { render, staticRenderFns } from "./CustodyExpenseInfo.vue?vue&type=template&id=5ded0852&"
import script from "./CustodyExpenseInfo.vue?vue&type=script&lang=js&"
export * from "./CustodyExpenseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports